import { Pipe, PipeTransform } from '@angular/core';

import { isParameterAllowed } from '../constants/constants';

@Pipe({ name: 'isParameterAllowed', standalone: true })
export class IsParameterAllowedPipe implements PipeTransform {
  transform(parameter: string, allowedParameters: any): boolean {
    return isParameterAllowed(parameter, allowedParameters);
  }
}
